import React, { forwardRef, useContext, useMemo } from 'react';
import clsx from 'clsx';
import { ScrollContext, SizeContext } from './context';
import styles from './styles.module.css';
import { OverrideButtonsContainer } from '../button/regular-button';
/**
 * `<DrawerFooter>` - Обёртка для контента подвала Drawer.
 * Предоставляет стили и логику для подвала`.
 */
export const DrawerFooter = /*#__PURE__*/forwardRef(function DrawerFooter({
  className,
  children,
  sticky,
  ...props
}, ref) {
  const testId = props['data-testid'] || 'drawer-footer';
  const {
    bottom
  } = useContext(ScrollContext);
  const size = useContext(SizeContext);
  const isWideButtons = size === 'xs' || size === 's';
  const classNameFooter = useMemo(() => clsx(styles.footer, {
    [styles.sticky]: !!sticky,
    [styles.shadow]: !!bottom
  }, className), [className, sticky, bottom]);
  return /*#__PURE__*/React.createElement("footer", {
    ...props,
    className: classNameFooter,
    ref: ref,
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(OverrideButtonsContainer, {
    hard: {
      wide: isWideButtons
    }
  }, children));
});